import styled, { css } from "styled-components";

export default styled.div`
  overflow: hidden;

  /* new swiper classes for racetrack */
  .racecard-area-slide {
    width: calc(100% - 16px);
    padding: 12px 0 12px 8px;
  }

  .racecard-area-slide:first-child {
    padding-left: 12px;
  }

  .racecard-area-slide:last-child {
    width: 100%;
    margin-right: 1px;
  }

  /*  end class for racetrack */

  /*  top races */
  .top-races-area-slide {
    max-width: 292px;
    margin: 0 0 0 8px;
    height: auto;
    padding-bottom: 2px;
  }

  .top-races-area-slide-desktop {
    max-width: auto;
    margin: 0;
    height: auto;
    padding-bottom: 2px;
  }

  .top-races-area-slide:first-of-type {
    margin-left: 12px;
  }

  .top-races-area-slide:last-child {
    margin-right: calc(100% - 292px);
    height: auto;
    min-height: 320px;
    max-width: 292px;
    padding-left: 8px;
  }

  .top-races-area-slide:last-child:first-child {
    padding-left: 12px;
  }

  .top-races-area-slide-desktop:last-child {
    margin-right: calc(100% - 292px);
    height: auto;
    min-height: 320px;
    max-width: auto;
    padding-left: 0;
  }

  /*  end top races */

  /*  talent picks */

  .talent-picks-area-slide {
    padding: 12px 0 2px;
    margin-left: 8px;
    max-width: 290px;

    &:first-of-type {
      margin-left: 12px;
    }

    &:last-child {
      margin-right: calc(100% - 292px);
    }
  }

  .talent-picks-area-slide-desktop {
    padding: 12px 0 2px;
    max-width: 312px;

    &:last-child {
      margin-right: calc(100% - 292px);
    }
  }

  .horse-switcher-area-slide {
    width: auto;
  }

  .other-payments-area-slide {
    width: auto;
    flex-grow: 1;
  }

  /* end talent picks */

  ${({ isDesktop }) =>
    isDesktop
      ? css`
          ${({ contextSA }) =>
            contextSA === "topraces"
              ? css`
                  margin: 12px 12px 0;
                `
              : css`
                  margin: 0 12px;
                `};
        `
      : css`
          width: 100%;
        `};
`;
